import { fillArr, getByOrder, randomNum } from '@hglobal/common';
import { MyMentoringStage, UserMentoringTask, MentoringStageStatus } from '@pt/models';

import { GetMyMentoringRes } from '../models';

export function getMentoringTasks(count: number): UserMentoringTask[] {
  return fillArr<UserMentoringTask>(
    count,
    i => (
      {
        id: i,
        title: `Task ${i}`,
        completed: Math.random() > 0.5,
      }
    ),
  );
}

export function createMentoringStage(i: number): MyMentoringStage {
  const requiredTasks = getMentoringTasks(randomNum(16, 6));
  const optionalTasks = getMentoringTasks(randomNum(6));
  const totalRequiredCompleted = requiredTasks.filter(t => t.completed).length;
  const totalOptionalCompleted = optionalTasks.filter(t => t.completed).length;
  const status
    = getByOrder(i, ['completed', 'inProgress', 'notStarted'] as const) as MentoringStageStatus;

  return {
    requiredTasks,
    optionalTasks,
    totalRequiredCompleted,
    totalOptionalCompleted,
    title: `Stage Name ${i}`,
    subtitle: `Stage Subtitle ${i}`,
    status,
    stageNumber: i,
    startedAt: status === 'inProgress' ? new Date().toISOString() : '',
    expiredAt: status === 'inProgress'
      ? new Date(Date.now() + (
        15.1 * 60 * 60 * 1000
      )).toISOString()
      : '',
    userMentoringId: i,
  };
}

export function getMyMentoring(count = 4): GetMyMentoringRes {
  const stages = fillArr<MyMentoringStage>(count, i => createMentoringStage(i));
  const totalStagesCompleted = stages.filter(stage => stage.status === 'completed').length;

  return {
    totalStages: count,
    totalStagesCompleted,
    stages,
    progress: Math.round((
      totalStagesCompleted / count
    ) * 100),
    userMentoringId: 12345,
  };
}
